module.exports = __webpack_public_path__ + "fonts/4c82e9f.otf";